export default "__VITE_ASSET__DYsH62DT__"